module.exports = __webpack_public_path__ + "static/media/graphql.7d4ee3f3.svg";